<template>
<div class="panelNagusia">
  <div class="ui breadcrumb">
    <a class="section" v-on:click="goTo('/dashboard')">Home</a>
    <i class="right angle icon divider"></i>
    <a class="section" v-on:click="goTo('/stats')">Estadísticas</a>
    <i class="right angle icon divider"></i>
    <a class="active section">Mensuales</a>
  </div>
  <h1 class="ui header">
    <img v-if="image_url" class="ui small image" :src="image_url">
    <img v-if="!image_url" class="ui small image" src="../../assets/name.png">
    <div class="content">Estadísticas {{client.toUpperCase()}}: {{year}} {{hilabetea}} </div>
  </h1>
  <div class="rightButton">
    <a class="section" v-on:click="changeMonth(year,month-1)"><i class="big arrow alternate circle down icon"></i></a>
    <a class="section" v-on:click="changeMonth(year,parseInt(month)+1)"><i class="big arrow alternate circle up icon"></i></a>
  </div>
  <div v-if="!data" class="ui active centered inline loader"></div>
  <div v-if="data" class="ui stackable one column divided grid container">
    <div class="row">
      <div class="column">
        <chartjs-line :fill="true" :datalabel="mylabel" :labels="mylabels" :data="mydata" :bordercolor="'#00f9a9'" :backgroundcolor="'rgba(0,249,169,0.1)'"></chartjs-line>
      </div>
    </div>
    <div class="row" style="text-align:center">
      <div class="column ">
        <div class="ui huge horizontal statistic">
          <div class="value">
            {{totala}}
          </div>
          <div class="label">{{client}}<br />PAQUETES RECOGIDOS EN<br />{{year}} {{hilabetea}}</div>
        </div>
      </div>
    </div>
  </div>
</div>
</template>
<script>
import { hapiickApi } from '@/api/hapiickApi';
export default {
  name: 'statsClientMonth',
  props: ['client', 'year', 'month'],
  data() {
    return {
      image_url: null,
      data: null,
      mylabels: null,
      mydata: null,
      hilabetea: null,
      totala: null,
      mylabel: 'Paquetes recogidos'
    }
  },
  created() {
    this.getImages()
    this.getStats(this.year, this.month)
  },
  methods: {
    async getImages() {
      await hapiickApi().get('/v1/images/stats?admin_id='+JSON.parse(localStorage.admin).id)
      .then(request => {
        this.images = JSON.parse(JSON.stringify(request.data.data))
        let url = this.images.find((e) => {
          return (e.key === this.client)
        })
        if (url !== undefined) {
          this.image_url = url.url
        } else {
          this.image_ur = null
        }
      })
      .catch((error) => {
        console.log('error getting images')
        console.log(error)
      })
    },
    getStats(year, month) {
      this.data = null
      let hoy = new Date();
      let current_year = hoy.getFullYear();
      let current_month = hoy.getMonth()+1;
      this.last_day = 31;

      if (year+'/'+month == current_year+'/'+current_month) {
        //this.last_day = hoy.getDate() + 1;
        this.last_day = hoy.getDate();
      }

      hapiickApi().post('/v3/stats/months', {
        admin_id: JSON.parse(localStorage.admin).id,
        year: year,
        month: month,
        client: this.client
      })
      .then(request => this.updateStatistics(request))
      .catch(() => console.log('error getting stats'))
    },
    updateStatistics(req) {
      this.hilabetea = this.$months[this.month-1] //this.$months >> main.js
      this.data = JSON.parse(JSON.stringify(req.data.data))
      let datuak = {...this.data.monthPicks};
      let egunak = []
      let zerrenda = []

      for (let i = 1; i <= this.last_day; i++) {
        egunak.push(this.year+'/'+this.month+'/'+i)

        if (i < 10) {
          i = '0' + i;
        } else {
          i = i;
        }

        let fecha = this.year+'-'+this.month.padStart(2, 0)+'-'+i;
        if (datuak.hasOwnProperty(fecha)) {
          zerrenda.push(datuak[fecha]);
        } else {
          zerrenda.push(0);
        }
      }
      this.mylabels = egunak
      this.mydata = zerrenda;
      this.totala=zerrenda.reduce((a, b) => a + b);
    },    
    goTo(where) {
      this.$router.push(where)
    },
    changeMonth(year, month) {
      if (month <= 0) {
        //year = year - 1
        year --;
        month = 12;
      } else if (month >= 13) {
        //year = year + 1
        year ++;
        month = 1;
      }
      this.goTo('/stats/' + this.client + '/' + year + '/' + month)
      this.getStats(year, month)
    }
  }
}
</script>
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Stats/statsClientMonth.vue